import { useSelector } from "react-redux";

import { getUserYearGroup } from "seneca-common/features/user/state";

import { useFeatureFlag } from "features/feature-flags";

import { isPrimaryApp } from "./logic";

export function useIsPrimaryApp() {
  const yearGroup = useSelector(getUserYearGroup);
  const featureFlagEnabled = !!useFeatureFlag("isPrimaryApp");

  return isPrimaryApp({
    yearGroup,
    featureFlagEnabled
  });
}
